import defaultTheme from './themes/default';
import blackFridayTheme from './themes/blackFriday';

// Temas disponíveis. A chave é o valor aceito em REACT_APP_THEME.
export const themes = {
    default: defaultTheme,
    blackFriday: blackFridayTheme,
};

// Tema ativo, escolhido em build pela env REACT_APP_THEME (ex.: REACT_APP_THEME=blackFriday).
// Valor ausente ou desconhecido cai no default.
const requested = process.env.REACT_APP_THEME;
export const activeTheme = themes[requested] || themes.default;

if (requested && !themes[requested] && process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.warn(`[theme] Tema "${requested}" não existe. Usando "default". Disponíveis: ${Object.keys(themes).join(', ')}`);
}

const toKebab = (str) => str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
const varName = (path) => `--c-${path.map(toKebab).join('-')}`;

// Achata { chrome: { headerBg: '#000' } } em [['--c-chrome-header-bg', '#000']]
export const flattenTokens = (colors, path = []) =>
    Object.entries(colors).flatMap(([key, value]) =>
        value && typeof value === 'object'
            ? flattenTokens(value, [...path, key])
            : [[varName([...path, key]), value]]
    );

// Mesma forma dos tokens, mas cada folha vira a referência CSS:
// vars.chrome.headerBg === 'var(--c-chrome-header-bg)'
// Funciona em styled-components, sx do MUI e style={{}} inline.
const buildVars = (colors, path = []) =>
    Object.fromEntries(
        Object.entries(colors).map(([key, value]) => [
            key,
            value && typeof value === 'object'
                ? buildVars(value, [...path, key])
                : `var(${varName([...path, key])})`,
        ])
    );

export const vars = buildVars(defaultTheme.colors);
